<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li class="last"><span><a href="/sirang/chisiamo">CHI SIAMO</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout" id="aui_3_4_0_1_591">
            <div class="aui-w70 portlet-column" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_H7pGyMq5rlnM_">
                     <span id="p_56_INSTANCE_H7pGyMq5rlnM"></span> 
                     <div class="portlet-body" id="aui_3_4_0_1_590">
                        <section class="portlet" id="portlet_56_INSTANCE_H7pGyMq5rlnM">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Chi siamo</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content" id="aui_3_4_0_1_589">
                              <div class=" portlet-content-container" style="" id="aui_3_4_0_1_588">
                                 <div class="portlet-body" id="aui_3_4_0_1_587">
                                    <div class="journal-content-article">
                                       <p>Il SIRA rappresenta lo strumento per gestire e diffondere l’informazione ambientale sia nella Pubblica Amministrazione, sia alle diverse categorie di soggetti privati, estendendo la conoscenza e l’accessibilità al patrimonio informativo in campo ambientale, permettendo di cogliere appieno le relazioni tra tutti gli oggetti del medesimo ambito geografico, offrendo in tal modo una più completa conoscenza dell’ambiente e delle pressioni che su di esso vengono esercitate.
                                          I temi che vengono gestiti riguardano l’ambiente in tutti i suoi aspetti, aria, acque, rifiuti, energia, agenti fisici, conservazione e siti contaminati.
                                          Il suo modello organizzativo e infrastrutturale di servizi è organizzato in una comune base di conoscenza ambientale, in cui le informazioni ambientali sono strutturate secondo le direttive e gli standard SINAnet e in conformità alle linee guida SPC-Coop e della Direttiva INSPIRE.
                                          E’ un sistema web based costituito da moduli comuni (modulo cartografico, modulo di business intelligence...). Il SIRA è anche un sistema web gis, sviluppato con tecnologie ESRI, che consente di recepire, rappresentare ed elaborare le informazioni anche sotto forma di cartografia, attraverso funzionalità di geoprocessing di base e avanzato.
                                          Il suo modulo GPA (gestione dei procedimenti amministrativi ambientali consente di gestire on-line di tutti i procedimenti amministrativi di rilevanza ambientale dalla richieste on-line sino al rilascio dell’atto finale.
                                          </p>
                                 </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
            <div class="aui-w30 portlet-column" id="column-2">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_RxuFFVEU5ofT_">
                     <span id="p_56_INSTANCE_RxuFFVEU5ofT"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_RxuFFVEU5ofT">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Sardegnaambiente</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <ul>
                                          <li> <a href="https://portal.sardegnasira.it/sistema-informativo-sira" target="_blank">Vai alla pagina</a></li>
                                       </ul>
                                    </div>
                                    <div class="entry-links"> </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>